import ReactECharts, { type EChartsOption } from "echarts-for-react";
import { useEffect, useMemo, useState } from "react";

type LoadingCountdownProps = {
  total: number;
  count?: number;
  color?: string;
  fontSize?: number;
  onEnd?: () => void;
};

export function LoadingCountdown({
  count = 0,
  color = "#a0a0a0",
  fontSize = 16,
  total,
  onEnd,
}: LoadingCountdownProps) {
  const [current, setCurrent] = useState(count);
  const option = useMemo<EChartsOption>(
    () => ({
      animation: false,
      responsive: true,
      series: [
        {
          name: "Loading Countdown",
          type: "pie",
          radius: ["40%", "70%"],
          label: {
            show: true,
            position: "center",
            fontSize,
            color,
          },
          labelLine: {
            show: false,
          },
          data: [
            {
              value: total - current,
              name: (total - current).toString(),
              itemStyle: {
                color,
                fontSize,
              },
              label: {
                show: true,
              },
            },
            {
              value: current,
              itemStyle: {
                opacity: 0,
              },
              label: {
                show: false,
              },
            },
          ],
        },
      ],
    }),
    [color, current, fontSize, total],
  );

  useEffect(
    function effectLoadingCountdownTick() {
      const interval = setInterval(() => {
        setCurrent((prev) => (prev < total ? prev + 1 : total));
      }, 1000);

      return () => clearInterval(interval);
    },
    [total],
  );

  useEffect(
    function effectLoadingCountdownEnd() {
      if (current === total) {
        onEnd?.();
      }
    },
    [current, onEnd, total],
  );

  return (
    <div className="relative h-full w-full">
      <ReactECharts
        option={option}
        opts={{
          renderer: "canvas",
        }}
        style={{
          height: "100%",
          width: "100%",
        }}
      />
    </div>
  );
}
